export default "__VITE_ASSET__50109b26__"